import api from "./core";

export default {
  getMenus() {
    return api.post(`api/core/Menus`, {});
  },
  getClient($id) {
    return api.get(`api/core/Patients/${$id}`);
  },
  getLevelsOfCare(orderBy) {
    return api.post(`api/core/Services`, {
      type: "LevelOfCare",
      orderBy: orderBy
    });
  },
  getUtilizationStatuses() {
    return api.post(`api/core/UrStatus`, {});
  },
  getLocations() {
    return api.post(`api/core/Locations`, {});
  },
  getUserLocations() {
    return api.post(`api/core/Locations/GetUserLocations`, {});
  },
  getVitalsForLocation(id) {
    return api.get(`api/core/Locations/${id}/vitals`, {});
  },
  getDoctorOrderForLocation(id) {
    return api.get(`api/core/Locations/${id}/doctorOrderFormId`);
  },
  getGenders() {
    return api.post(`api/core/Gender`, {});
  },
  getPronouns() {
    return api.post(`api/core/Pronoun`, {});
  },
  getMaritalStatuses() {
    return api.post(`api/core/MaritalStatus`, {});
  },
  getStates() {
    return api.post(`api/core/State`, {});
  },
  getAllergyTypes() {
    return api.post(`api/core/AllergyType`, {});
  },
  getAllergySeverities() {
    return api.post(`api/core/AllergySeverity`, {});
  },
  getRelationships() {
    return api.post(`api/core/Relationships`, {});
  },
  getCaseRoles() {
    return api.post(`api/core/CaseRoles`, {});
  },
  getDiagnosisCodeStatuses() {
    return api.post(`api/core/DiagnosisCodeStatus`, {});
  },
  getNutritionCategories() {
    return api.post(`api/core/NutritionCategory`, {});
  },
  getNutritionMeals() {
    return api.post(`api/core/NutritionMeal`, {});
  },
  getAllergens() {
    return api.post(`api/core/Allergen`, {});
  },
  getReactions() {
    return api.post(`api/core/Reaction`, {});
  },
  getReviewTypes() {
    return api.post(`api/core/UrReviewType`, {});
  },
  getInsuranceCoverages() {
    return api.post(`api/core/InsuranceCoverage`, {});
  },
  getMedicationRoutes() {
    return api.post(`api/core/MedicationRoute`, {});
  },
  getMeasurements() {
    return api.post(`api/core/UnitOfMeasurement`, {});
  },
  getSexes() {
    return api.post(`api/core/Sexes`, {});
  },
  getTaxonomySpecialties() {
    return api.post(`api/core/TaxonomySpecialty`, {});
  },
  getTaxonomyTypes() {
    return api.post(`api/core/TaxonomyType`, {});
  },
  getEntityTypes() {
    return api.post(`api/core/EntityType`, {});
  },
  getPayerTypes() {
    return api.post(`api/core/PayerTypes`, {});
  },
  getScheduleEventTypes() {
    return api.post(`api/core/ScheduleEventType`, {});
  },
  getScheduleEventStatuses() {
    return api.post(`api/core/ScheduleEventStatus`, {});
  },
  getRaces() {
    return api.post(`api/core/Race`, {});
  },
  getEthnicities() {
    return api.post(`api/core/Ethnicity`, {});
  },
  getLanguages() {
    return api.post(`api/core/Language`, {});
  },
  getPredefinedProtocols() {
    return api.post(`api/core/PredefinedProtocol`, {
      page: 0,
      pageSize: 1000000
    });
  },
  getPlacesOfService() {
    return api.post(`api/core/PlaceOfService`, {});
  },
  getSharePackages() {
    return api.post(`api/core/SharePackages`);
  },
  getDischargeReasons() {
    return api.post(`api/core/DischargeReason`);
  }
};
